import { AnalyticsService } from '../services/analytics'

// "DO WE COVER YOU?" (Robin, 28 Oct 2026): the postcode box under a wash
// page's Book button (app/views/gwmc/_coverage_check) and on /services
// (components/coverage-check). The answer is the server's, GET /coverage
// (CoverageCheck: the booking form's own area rule, outward code only, no
// lookup), and so are its words and its Book button (`html`, the same
// partial a wash page renders without JavaScript). This only asks, puts the
// answer under the box and sends coverage_checked.
//
// `root` is the [data-coverage-check] element; its value is the wash page's
// slug ('' on /services). Returns the clean-up.
export const wireCoverageCheck = root => {
  const form = root && root.querySelector('form')
  const input = form && form.querySelector('input')
  const answer = root && root.querySelector('[data-coverage-answer]')
  if (!form || !input || !answer) return undefined

  const wash = root.getAttribute('data-coverage-check') || null
  let asked = 0

  const onSubmit = async event => {
    event.preventDefault()
    const mine = ++asked
    const query = new URLSearchParams({ postcode: input.value })
    if (wash) query.set('wash', wash)
    try {
      const response = await fetch(`/coverage?${query}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      if (!response.ok) throw new Error(`coverage ${response.status}`)
      const data = await response.json()
      if (mine !== asked) return
      answer.innerHTML = data.html
      if (data.result === 'invalid') input.setAttribute('aria-invalid', 'true')
      else input.removeAttribute('aria-invalid')
      AnalyticsService.trackCoverageChecked({ result: data.result, wash, outward: data.outward || null })
    } catch (e) {
      // No answer from us: a wash page's form answers on the server.
      if (form.hasAttribute('data-coverage-server')) form.submit()
    }
  }

  form.addEventListener('submit', onSubmit)
  return () => form.removeEventListener('submit', onSubmit)
}
